<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de prioridade">
            <template v-slot:actions>
                <rkm-button
                    @click="$router.push({name: 'painel-senha-prioridade-create'})"
                    authorize="store-painel-senha-prioridade"
                    color="primary"
                >
                    Cadastrar prioridade
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/painel-senha/prioridade/List'

export default {
    components: {List},
}
</script>